import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_CON024_Request,
  IAPI_CON024_Response,
  IAPI_CON026_Request,
  IAPI_CON026_Response,
} from "../../../type/apiType";

// 契約者申請情報参照
const httpAPI_CON024 = async (
  param: IAPI_CON024_Request
): Promise<IAPI_CON024_Response> => {
  let res = await http.post(ApiUrl.API_CON024, {
    ...param,
  });

  return res.data;
};

// 共済契約申請書更新
const httpAPI_CON026 = async (
  param: IAPI_CON026_Request
): Promise<IAPI_CON026_Response> => {
  let res = await http.post(ApiUrl.API_CON026, {
    ...param,
  });

  return res.data;
};

export { httpAPI_CON026, httpAPI_CON024 };
